import { render } from "./phone-guide.vue?vue&type=template&id=9c477264&scoped=true"
import script from "./phone-guide.vue?vue&type=script&lang=js"
export * from "./phone-guide.vue?vue&type=script&lang=js"

import "./phone-guide.vue?vue&type=style&index=0&id=9c477264&scoped=true&lang=scss"

import exportComponent from "F:\\my-work\\company\\yuanxi\\yuanxi-csspw\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9c477264"]])

export default __exports__